<template>
  <div>
    <div class="mt20">
      <spinner-three-bounce :displayNone="!isLoading"/>
      <div class="centerText " v-if="isLoading">
        <h3>
          Veuillez patienter pendant le chargement de vos données.
        </h3>
        <p>
          Relaxez-vous et prenez une grande inspiration.
        </p>
      </div>
    </div>

    <div v-show="!isLoading">
      <!-- detail Virement  -->
      <div class="row">
        <div class="col-lg-12">
          <div class="col-lg-6">
            <div class="widget navy-bg no-padding widget-lemonway">
              <div v-if="errorWalletSeller || errorWalletSellerStatus" class="widget red-bg no-padding widget-lemonway">
                <div class="p-m">
                  <a :href="walletInfo.seller.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="font-bold no-margins">
                        {{ getVirementWallet }}
                      </h3>
                      <h1 class="m-xs">{{ walletInfo.seller.wallet.totalAmount | formatDecimalPrice }} €</h1>
                      <small >{{ walletInfo.seller.wallet.message }}<br></small>
                      <small ><i class="fa fa-building"></i> {{ walletInfo.seller.wallet.id.carizy }}</small>
                    </div>
                    <div class="col-lg-6">
                      <div class="text-center">
                        <i class="fa fa-warning fa-4x"></i>
                        <h3 class="m-xs error">{{ errorWalletSeller }} </h3>
                        <h3 v-if="errorWalletSellerStatus" class="m-xs error">{{ errorWalletSellerStatus }} </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="widget navy-bg no-padding widget-lemonway">
                <div class="p-m">
                  <a :href="walletInfo.seller.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                  <h3 class="font-bold no-margins">
                    {{ getVirementWallet }}
                  </h3>
                  <h1 class="m-xs">{{ walletInfo.seller.wallet.totalAmount | formatDecimalPrice }} €</h1>
                  <small>{{ walletInfo.seller.wallet.message }}<br></small>
                  <small ><i class="fa fa-building"></i> {{ walletInfo.seller.wallet.id.carizy }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div v-if="errorWalletBuyer" class="widget red-bg no-padding widget-lemonway">
              <div class="p-m">
                <a :href="walletInfo.buyer.wallet.url || errorWalletBuyerStatus" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                <div class="row">
                  <div class="col-lg-6">
                    <h3 class="font-bold no-margins">
                      {{ getVirementLabel }}
                    </h3>
                    <h1 class="m-xs">
                      {{ walletInfo.buyer.wallet.totalAmount | formatDecimalPrice }} €
                    </h1>
                    <small>{{ walletInfo.buyer.wallet.message }}</small>
                  </div>
                  <div class="col-lg-6">
                    <div class="text-center">
                      <i class="fa fa-warning fa-4x"></i>
                      <h3 class="m-xs error">{{ errorWalletBuyer }} </h3>
                      <h3 v-if="errorWalletBuyerStatus" class="m-xs error">{{ errorWalletBuyerStatus }} </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="widget no-padding widget-lemonway" :class="warningWalletBuyer === false ? 'navy-bg' : 'yellow-bg'">
              <div class="p-m">
                <a :href="walletInfo.buyer.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                <div class="col-lg-6">
                  <h3 class="font-bold no-margins">
                    {{ getVirementLabel }}
                  </h3>
                  <h1 class="m-xs">
                    {{ walletInfo.buyer.wallet.totalAmount | formatDecimalPrice }} €
                  </h1>
                  <small>{{ walletInfo.buyer.wallet.message }}</small>
                </div>
                <div class="col-lg-6" v-if="warningWalletBuyer === true">
                  <div class="text-center">
                    <i class="fa fa-bell fa-4x"></i>
                    <h3 class="m-xs error">Solde wallet supérieur à la commande</h3>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- fin lemonway  -->
      <IbanBuyer :customerId="buyer.id"></IbanBuyer>
      <Accordion title="Détail de la commande" titleIcon="fa fa-usd">
        <template slot="content">
          <div class="row">
            <div class="col-lg-12">
              <div>
                <div class="row">
                  <div class="col-sm-6">
                    <h4>Commande : <span class="text-navy"> <strong>#{{ commandId }} </strong></span></h4>
                    <h4>Créée le&nbsp;: <span class="text-navy"><strong>{{ command.creationDate | formatDate }}</strong></span></h4>
                    <h4>Moyen de paiement : <strong class="text-navy">{{ getPaymentLabel }}</strong></h4>
                    <h4 class="statuCmd">Status : <strong> <component-status :status="command.status"></component-status> </strong> </h4>
                  </div>
                </div>

                <div class="table-responsive m-t">
                  <table class="table invoice-table table-striped">
                    <tbody>
                    <tr>
                      <td>
                        <div class="table-lemonway">
                          <p>{{ this.vehicle.make }} {{ this.vehicle.version }}</p>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.buyerPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr class="make">
                      <td class="make-list">
                        <div>
                          <strong>Dont net vendeur</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.sellerPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr class="make">
                      <td class="make-list">
                        <div>
                          <strong>Dont commision</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.saleCommission | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="options.disposalType">
                      <td>
                        <div>
                          <strong>{{ getDisposalLabel }}</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.deliveryPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="warrantyOptions.length && options.warranty">
                      <td>
                        <div class="table-lemonway">
                          <p>{{ getWarrantyLabel }}</p>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.warranty.price | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Carte Grise</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.registrationCertificatePrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="orderInfo.carRegistrationDocumentEcoTaxPrice !== 0">
                      <td>
                        <div>
                          <strong>Dont écotaxe</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.carRegistrationDocumentEcoTaxPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Immatriculation</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.registrationPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Frais De Réservation</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.feesPrice | formatDecimalPrice }} €</td>
                    </tr>

                    </tbody>
                  </table>
                </div><!-- /table-responsive -->

                <table class="table invoice-total">
                  <tbody>
                  <tr class="total">
                    <td><strong>TOTAL DÛ :</strong></td>
                    <td class="text-navy">{{ orderInfo.totalAmount | formatDecimalPrice }} €</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <div class="row diac-lemonway">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5><i class="fa fa-credit-card-alt"></i> Virement</h5>
            </div>
            <div class="ibox-content">
              <div class="owner-wizard">
                <ul class="steps">
                  <li v-for="(step, index) in steps"
                      :key="index"
                      :class="[index + 1 === activeStep ? 'active' : 'allowed']"
                      @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
                </ul>
                <component
                    :getTotalAmount="getTotalAmount"
                    :getNetVendeurAmount="getNetVendeurAmount"
                    :getTotalAmountForCheque="getTotalAmountForCheque"
                    :isvalidSeller="walletInfo.seller.wallet.isValid"
                    :isvalidBuyer="walletInfo.buyer.wallet.isValid"
                    :getWalletSellerAmount="getWalletSellerAmount"
                    :getWalletBuyerAmount="getWalletBuyerAmount"
                    :is="component" :status="command.status"
                    :paymentMode="command.paymentMode"
                    :statuSaller="walletInfo.seller.wallet.status"
                    :statuBuyer="walletInfo.buyer.wallet.status"
                    :walletVdr="getVirementWallet"
                    :walletAct="getVirementLabel"
                    :getPaymentLabel="getPaymentLabel"
                    :orderId="commandId"
                    :customerId="buyer.id"
                    :sellerMessageStatus="walletInfo.seller.wallet.message"
                    :buyerMessageStatus="walletInfo.buyer.wallet.message"
                    :idCustomerSeller = "walletInfo.seller.wallet.id.customer"
                    :idCustomerBuyer = "walletInfo.buyer.wallet.id.customer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Controle from '../../components/details/lemonway/Controle'
import VirementExterne from '../../components/details/lemonway/VirementExterne'
import VirementP2p from '../../components/details/lemonway/VirementP2p'
import {appointmentMode, paymentMode} from '@/helpers/utils/constants'
import Status from "@/components/details/Status.vue"
import Alert from '../../components/Alert.vue'
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
import Accordion from '@/components/accordion/accordion'
import { isAddressIncompleteMixin } from '@/mixins/isAddressIncompleteMixin'
import store from "@/config/store";
import WarrantyOptionList from "@/api/query/WarrantyOptionList.gql";
import IbanBuyer from "@/components/details/lemonway/IbanBuyer.vue";

const BANK_CHECK_PAYMENT_MODE = paymentMode.BANK_CHECK_PAYMENT_MODE
const TRANSFER_PAYMENT_MODE = paymentMode.TRANSFER_PAYMENT_MODE
const CREDIT_PAYMENT_MODE_MOBILIZE = paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE
const CREDIT_PAYMENT_MODE_COFIDIS = paymentMode.CREDIT_PAYMENT_MODE_COFIDIS
const CREDIT_PAYMENT_MODE_YOUNITED = paymentMode.CREDIT_PAYMENT_MODE_YOUNITED

export default {
  name: "VirementDiac",

  props: {
    command: {
      type: Object,
      required: true
    },
  },

  components: {
    'component-alert': Alert,
    'component-status': Status,
    SpinnerThreeBounce,
    Accordion,
    'controle': Controle,
    'virementExterne': VirementExterne,
    'virementP2p': VirementP2p,
    'IbanBuyer': IbanBuyer,
  },

  mixins: [isAddressIncompleteMixin],

  data: () => ({
    blocks: [
      'controle',
      'virementP2p',
      'virementExterne',
    ],
    blockDiac: [
      'virementP2p',
    ],
    steps: [
      'Contrôles',
      'Virement P2P',
      'Virement Externe'
    ],
    stepDiac: [
      'Virement P2P',
    ],
    activeStep: 1,
    paymentMode: {
      BANK_CHECK_PAYMENT_MODE: BANK_CHECK_PAYMENT_MODE,
      TRANSFER_PAYMENT_MODE: TRANSFER_PAYMENT_MODE,
      CREDIT_PAYMENT_MODE_MOBILIZE: CREDIT_PAYMENT_MODE_MOBILIZE,
      CREDIT_PAYMENT_MODE_COFIDIS: CREDIT_PAYMENT_MODE_COFIDIS,
      CREDIT_PAYMENT_MODE_YOUNITED: CREDIT_PAYMENT_MODE_YOUNITED
    },
    walletInfo: {
      seller: {
        wallet: {
          status: "",
          isValid: "",
          totalAmount: "",
          message: "",
          url: "",
          id: {
            carizy: "",
            lemonway: "",
            customer: ""
          }
        }
      },
      buyer: {
        wallet: {
          status: "",
          isValid: "",
          totalAmount: "",
          message: "",
          url: "",
          id: {
            carizy: "",
            lemonway: "",
            customer: ""
          }
        }
      },
    },
    walletInfoDiac: {
      wallet: {
        status: "",
        isValid: "",
        totalAmount: "",
        message: "",
        url: "",
        id: {
          carizy: "",
          lemonway: ""
        }
      }
    },
    orderInfo: {
      warranty: {
        label: "",
        price: 0,
      },
      delivery: {
        address: "",
        zipCode: "",
        city: "",
      },
      deliveryPrice: "",
      paymentMode: "",
      feesPrice: "",
      registrationCertificatePrice: 0,
      carRegistrationDocumentEcoTaxPrice: 0,
      registrationPrice: 0,
      receivedAmount: "",
      totalAmount: "",
      remainingAmount: "",
      saleCommission: "",
      overAmount: "",
      buyerPrice: "",
      sellerPrice: "",
      changeOptionsAmount: "",
      totalOperationAmount: "",
      totalAmountForCheque: ""
    },
    delivery: {
      isDelivery: false,
      address: {
        address: "",
        city: "",
        zipCode: ""
      },
      coordinate: {
        start: {
          latitude: null,
          longitude: null,
        },
        end: {
          latitude: null,
          longitude: null,
        }
      }
    },
    warrantyOptions: [],
    options: {
      warranty: null,
      payment: null,
      disposalType: null,
      registration: null,
      carRegistrationDocument: null
    },
    customersBalanceDiacQueryisLoading: false,
    customersBalanceQueryisLoading: false,
    getOrderInformationQueryisLoading: false,
    externalTransferHistory: {
      date: "",
      user: "",
      comment: "",
      command: ""
    },
    paymentControllInfo: {
      status: "",
    },
    fromBO: true,
    zip: null
  }),

  computed: {
    adSupplier () {
      return this.command.ad.supplier
    },
    isVenteDirect () {
      return this.adSupplier === 'renault'
    },
    getWarrantyLabel () {
      return this.orderInfo.warranty.label
    },
    getDisposalLabel () {
      switch (this.options.disposalType) {
        case appointmentMode.DELIVERY:
          return 'Livraison'
        case appointmentMode.DISPOSAL:
          return 'Rendez-vous de cession'
        default:
          return ''
      }
    },
    getTotalAmount () {
      return this.orderInfo.totalAmount
    },
    getNetVendeurAmount () {
      return this.orderInfo.sellerPrice
    },
    getTotalAmountForCheque() {
      return this.orderInfo.totalAmountForCheque
    },
    getWalletBuyerAmount () {
      return this.walletInfo.buyer.wallet.totalAmount
    },
    getWalletSellerAmount () {
      return this.walletInfo.seller.wallet.totalAmount
    },
    component () {
      return this.blocks[this.activeStep - 1]
    },
    componentDiac () {
      return this.blockDiac[this.activeStep - 1]
    },
    getVirementLabel () {
      return 'Wallet Acheteur'
    },
    getVirementWallet () {
      return 'Wallet Vendeur'
    },
    getPaymentLabel () {
      switch (this.options.payment) {
        case paymentMode.TRANSFER_PAYMENT_MODE:
          return 'Virement bancaire'
        case paymentMode.BANK_CHECK_PAYMENT_MODE:
          return 'Chèque de banque'
        case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
          return 'Crédit MOBILIZE'
        case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
          return 'Crédit COFIDIS'
        case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
          return 'Crédit YOUNITED'
        default:
          return ''
      }
    },
    isLoading () {
      if (
          this.customersBalanceDiacQueryisLoading ||
          this.customersBalanceQueryisLoading ||
          this.getOrderInformationQueryisLoading
      ) {
        return true
      } else {
        return false
      }
    },
    zipCode () {
      return this.delivery.address.zipCode;
    },
    commandId () {
      return this.$route.params.id
    },
    vehicle () {
      return this.command.vehicule[0]
    },
    buyer () {
      return this.command.buyer[0]
    },
    errorWalletSeller () {
      let walleterror = ""
      if (this.walletInfo.seller.wallet.status === 0) walleterror = "Aucun wallet trouvé"
      return walleterror
    },
    warningWalletBuyer () {
      let walleterror = false
      if (this.getPaymentLabel === 'Chèque de banque'){
        if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque) walleterror = true
      }else if (this.walletInfo.buyer.wallet.totalAmount > this.orderInfo.totalAmount) walleterror = true

      return walleterror
    },
    errorWalletBuyer () {
      let walleterror = ""
      if (this.walletInfo.buyer.wallet.status === 0) walleterror = "Aucun wallet trouvé"
      else {
        if (this.getPaymentLabel === 'Chèque de banque'){
          if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque & this.walletInfo.buyer.wallet.isValid === false) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.isValid === false)  walleterror = "Vérifier le statut du wallet"

        } else {
          if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmount & this.walletInfo.buyer.wallet.isValid === false) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmount) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.isValid === false) walleterror = "Vérifier le statut du wallet"
        }
      }
      return walleterror
    },
    errorWalletBuyerStatus () {
      let walleterrorStatus = ""
      if (this.walletInfo.buyer.wallet.status !== 0 ) {
        if (this.walletInfo.buyer.wallet.status !== 5 && this.walletInfo.buyer.wallet.status !== 6 && this.walletInfo.buyer.wallet.status !== 16) walleterrorStatus = "Statut du wallet doit être à KYC 1, KYC 2 ou Client occasionnel"
      }
      return walleterrorStatus
    },
    errorWalletSellerStatus () {
      let walleterrorStatus = ""
      if (this.walletInfo.seller.wallet.status !== 0 ) {
        if (this.getPaymentLabel !== 'Chèque de banque' && this.walletInfo.seller.wallet.status !== 6) walleterrorStatus = "Statut du wallet doit être à KYC 2"
        else if (this.getPaymentLabel === 'Chèque de banque' && this.walletInfo.seller.wallet.status === 10) walleterrorStatus = "Wallet status Bloqué"
      }
      return walleterrorStatus
    },
    getErrorStatus () {
      let errorstatus = ""
      if (this.command.status !== "Cession finalisée") errorstatus = "La cession de la commande n'est pas finalisée"
      return errorstatus
    }
  },

  OrderInformationQuery () {
    this.$apollo.query({
      query: this.getOrderInformationQuery
    }).then((response) => {
      if (response.data.checkPromoCode.isValid) {
        this.errorWallet = response.data.checkPromoCode
      } else {
        this.codePromo.details = null
        this.showBanner('danger', `Le code promo indiqué n'est pas valide`)
      }
    })
  },

  async created () {
    this.zip = this.command.zip
    if (this.command.options !== null) {
      this.command.options.map((x) => {
        if (x.type === "warranty") this.options.warranty = x.id
        if (x.type === "immatriculation") this.options.registration = x.id
        if (x.type === "immatriculationDocument") this.options.carRegistrationDocument = x.id
      })
    }
    await this.getOrderInformationQuery()
    await this.getCustomersBalanceQuery()
    await this.getCustomersBalanceDiacQuery()
    await this.getExternalTransferHistory()
    await this.getPaymentControlQuery()
    if (this.paymentControllInfo.status === true) this.$parent.toggleBlock(3)
    this.options.disposalType = this.command.delivery ? appointmentMode.DELIVERY : appointmentMode.DISPOSAL
    this.options.payment = this.command.paymentMode
    if (this.options.disposalType === appointmentMode.DELIVERY) {
      this.delivery.isDelivery = true;
    }
    if (this.command.promoCode) {
      this.codePromo.details = this.command.promoCode
    }
    store.order.id = this.$route.params.id
  },

  methods: {
    toggleBlock (step) {
      this.activeStep = step
    },
    async getOrderInformationQuery () {
      this.getOrderInformationQueryisLoading = true
      let isRegistrationDocument = this.options.carRegistrationDocument ? true : false
      let isRegistration = this.options.registration ? true : false

      const orderInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getOrderInformation (orderId: ${this.commandId}, warranty: ${this.options.warranty}, paymentMode: ${this.options.payment}, isDelivery: "${this.delivery.isDelivery}",
                      isRegistrationDocument: "${isRegistrationDocument}",
                      isRegistration: "${isRegistration}",
                      zip: "${this.zip}",
                      delivery: {
                          address: "${this.delivery.address.address}",
                          zipCode: "${this.delivery.address.zipCode}",
                          city: "${this.delivery.address.city}",
                          coordinate: {
                              start: {
                                  latitude: ${this.delivery.coordinate.start.latitude},
                                  longitude: ${this.delivery.coordinate.start.longitude},
                              },
                              end: {
                                  latitude: ${this.delivery.coordinate.end.latitude},
                                  longitude: ${this.delivery.coordinate.end.longitude},
                              }
                          }
                        }
                        ) {
                        warranty { label price}
                        deliveryPrice
                        paymentMode
                        feesPrice
                        registrationCertificatePrice
                        carRegistrationDocumentEcoTaxPrice
                        receivedAmount
                        totalAmount
                        remainingAmount
                        saleCommission
                        overAmount
                        buyerPrice
                        sellerPrice
                        changeOptionsAmount
                        totalOperationAmount
                        totalAmountForCheque
                        carRegistrationDocumentPrice
                        carRegistrationPrice
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.orderInfo.warranty.label = orderInfo.data.getOrderInformation.warranty.label
      this.orderInfo.warranty.price = orderInfo.data.getOrderInformation.warranty.price ? orderInfo.data.getOrderInformation.warranty.price : 0
      this.orderInfo.deliveryPrice = orderInfo.data.getOrderInformation.deliveryPrice
      this.orderInfo.paymentMode = orderInfo.data.getOrderInformation.paymentMode
      this.orderInfo.feesPrice = orderInfo.data.getOrderInformation.feesPrice
      this.orderInfo.registrationCertificatePrice = orderInfo.data.getOrderInformation.carRegistrationDocumentPrice
      this.orderInfo.carRegistrationDocumentEcoTaxPrice = orderInfo.data.getOrderInformation.carRegistrationDocumentEcoTaxPrice
      this.orderInfo.registrationPrice =  orderInfo.data.getOrderInformation.carRegistrationPrice
      this.orderInfo.receivedAmount = orderInfo.data.getOrderInformation.receivedAmount
      this.orderInfo.totalAmount = orderInfo.data.getOrderInformation.totalAmount
      this.orderInfo.remainingAmount = orderInfo.data.getOrderInformation.remainingAmount
      this.orderInfo.saleCommission = orderInfo.data.getOrderInformation.saleCommission
      this.orderInfo.overAmount = orderInfo.data.getOrderInformation.overAmount
      this.orderInfo.buyerPrice = orderInfo.data.getOrderInformation.buyerPrice
      this.orderInfo.sellerPrice = orderInfo.data.getOrderInformation.sellerPrice
      this.orderInfo.changeOptionsAmount = orderInfo.data.getOrderInformation.changeOptionsAmount
      this.orderInfo.totalOperationAmount = orderInfo.data.getOrderInformation.totalOperationAmount
      this.orderInfo.totalAmountForCheque = orderInfo.data.getOrderInformation.totalAmountForCheque

      this.getOrderInformationQueryisLoading = false

    },
    async getCustomersBalanceQuery () {
      this.customersBalanceQueryisLoading = true

      const walletInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getCustomersBalance (
                        orderId: ${this.commandId}
                        ) {
                        seller {
                            wallet {
                                status,
                                isValid,
                                totalAmount,
                                message,
                                url,
                                id {
                                    carizy,
                                    lemonway
                                }
                            }
                        }
                        buyer {
                            wallet {
                                status,
                                isValid,
                                totalAmount,
                                message,
                                url,
                                id {
                                    carizy,
                                    lemonway
                                }
                            }
                        }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.walletInfo.seller.wallet.status = walletInfo.data.getCustomersBalance.seller.wallet.status
      this.walletInfo.seller.wallet.isValid = walletInfo.data.getCustomersBalance.seller.wallet.isValid
      this.walletInfo.seller.wallet.totalAmount = walletInfo.data.getCustomersBalance.seller.wallet.totalAmount
      this.walletInfo.seller.wallet.message = walletInfo.data.getCustomersBalance.seller.wallet.message
      this.walletInfo.seller.wallet.url = walletInfo.data.getCustomersBalance.seller.wallet.url
      this.walletInfo.seller.wallet.id.carizy = walletInfo.data.getCustomersBalance.seller.wallet.id.carizy
      this.walletInfo.seller.wallet.id.lemonway = walletInfo.data.getCustomersBalance.seller.wallet.id.lemonway
      this.walletInfo.seller.wallet.id.customer = walletInfo.data.getCustomersBalance.seller.wallet.id.customer
      this.walletInfo.buyer.wallet.status = walletInfo.data.getCustomersBalance.buyer.wallet.status
      this.walletInfo.buyer.wallet.isValid = walletInfo.data.getCustomersBalance.buyer.wallet.isValid
      this.walletInfo.buyer.wallet.totalAmount = walletInfo.data.getCustomersBalance.buyer.wallet.totalAmount
      this.walletInfo.buyer.wallet.message = walletInfo.data.getCustomersBalance.buyer.wallet.message
      this.walletInfo.buyer.wallet.url = walletInfo.data.getCustomersBalance.buyer.wallet.url
      this.walletInfo.buyer.wallet.id.carizy = walletInfo.data.getCustomersBalance.buyer.wallet.id.carizy
      this.walletInfo.buyer.wallet.id.lemonway = walletInfo.data.getCustomersBalance.buyer.wallet.id.lemonway
      this.walletInfo.buyer.wallet.id.customer = walletInfo.data.getCustomersBalance.buyer.wallet.id.customer

      this.customersBalanceQueryisLoading = false
    },
    async getCustomersBalanceDiacQuery () {
      this.customersBalanceDiacQueryisLoading = true

      const walletInfoDiac = await this.$apollo.query({
        query: gql`
               query {
                     getDiacBalance {
                        wallet {
                           status,
                           isValid,
                           totalAmount,
                           message,
                           url,
                           id {
                             carizy,
                             lemonway
                           }
                        }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.walletInfoDiac.wallet.status = walletInfoDiac.data.getDiacBalance.wallet.status
      this.walletInfoDiac.wallet.isValid = walletInfoDiac.data.getDiacBalance.wallet.isValid
      this.walletInfoDiac.wallet.totalAmount = walletInfoDiac.data.getDiacBalance.wallet.totalAmount
      this.walletInfoDiac.wallet.url = walletInfoDiac.data.getDiacBalance.wallet.url
      this.walletInfoDiac.wallet.message = walletInfoDiac.data.getDiacBalance.wallet.message
      this.walletInfoDiac.wallet.id.carizy = walletInfoDiac.data.getDiacBalance.wallet.id.carizy
      this.walletInfoDiac.wallet.id.lemonway = walletInfoDiac.data.getDiacBalance.wallet.id.lemonway

      this.customersBalanceDiacQueryisLoading = false
    },
    async getPaymentControlQuery () {
      const PaymentControlInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getPaymentControl (orderId: ${this.commandId}) {
                        status
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.paymentControllInfo.status = PaymentControlInfo.data.getPaymentControl.status

    },
    async getExternalTransferHistory () {
      this.externalTransferHistoryComment = true
      const externalTransferHistory = await this.$apollo.query({
        query: gql`
              query {
                     externalTransferHistory (orderId: ${this.commandId}) {
                        date,
                        user,
                        comment,
                        command,
                    }
              }`,
        fetchPolicy: 'no-cache'
      })
      this.externalTransferHistory.date = externalTransferHistory.data.externalTransferHistory.date
      this.externalTransferHistory.user = externalTransferHistory.data.externalTransferHistory.user
      this.externalTransferHistory.comment = externalTransferHistory.data.externalTransferHistory.comment
      this.externalTransferHistory.command = externalTransferHistory.data.externalTransferHistory.command
      this.externalTransferHistoryComment = false

    },

  },

  apollo: {
    warrantyOptions: {
      query: WarrantyOptionList,
      variables () {
        return {
          orderId: this.commandId,
          fromBO: this.fromBO
        }
      },
    }
  }
}
</script>
